"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUser = getCurrentUser;
const utils_1 = require("@aws-amplify/core/internals/utils");
const getCurrentUser_1 = require("./internal/getCurrentUser");
async function getCurrentUser(...args) {
    const [ctx] = (0, utils_1.resolveCtxArgs)(args);
    return (0, getCurrentUser_1.getCurrentUser)(ctx);
}
